export { HasConsent } from './has-consent'
